import { Component, ViewEncapsulation } from "@angular/core";
import { NgForm } from "@angular/forms";
import * as _ from "lodash-es";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { SubSink } from "subsink";
import { RosterSummaryLineService } from "../services/roster-summery-line.service";
import { IRosterCode } from "../shared/models/roster-code";
import { IRosterSummaryFormular } from "../shared/models/roster/roster-summary-formular";
import { IRosterSummaryLine } from "../shared/models/roster/roster-summary-line";
import { SummaryFormular } from "../shared/models/roster/summary-formular";
import { IEntity } from "../shared/models/entity";
import { IRosterProject } from "../shared/models/roster/roster-project";
import { IEmployer } from "../shared/models/employer";

@Component({
  selector: "pps-roster-summary-line-form",
  templateUrl: "./roster-summary-line-form.component.html",
  styles:[`
    .roster-summary-line-form .item {
      display: flex;
      align-items: center;
      padding: 0rem 0.5rem;
      width: 100%;
    }
    .roster-summary-line-form .p-picklist .p-picklist-list .p-picklist-item{
      padding: 0rem;
    }
    /*
    This class is important to make sure the drag preview item is not displayed beneath the dynamic dialog. 
    Another way is to set autoZIndex = false when open the component in addOrUpdateRosterSummaryLine() method
    */
    .p-picklist-item.cdk-drag-preview{
      z-index:2000 !important;
      padding: 0rem 0.75rem;
    }
  `],
  encapsulation: ViewEncapsulation.None
})
export class RosterSummaryLineFormComponent{
  private subs = new SubSink();

  errorMessage = "";
  workGroups: IEntity[] = [];
  rosterCodes: IRosterCode[] = [];
  rosterProjects: IRosterProject[] = [];
  employers: IEmployer[] = [];
  
  selectedEmployers: IEmployer[] = [];
  selectedWorkGroups: IEntity[] = [];
  rosterSummaryLine: IRosterSummaryLine = {};
  
  rosterSummaryFormulars: IRosterSummaryFormular [] = [
    {id: SummaryFormular.OnSite, formularName: "On Site"},
    {id: SummaryFormular.OffSite, formularName: "Off Site"},
    {id: SummaryFormular.RosterCode, formularName: "Roster Code"}
  ];  
  
  constructor(
    private _dialogRef: DynamicDialogRef,
    private _dlgConfig: DynamicDialogConfig,
    private _rosterSummaryLineService: RosterSummaryLineService) {
    this.setData(this._dlgConfig.data);
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  setData(data: any){
    this.workGroups = _.cloneDeep(data.workGroups);
    this.rosterCodes = _.cloneDeep(data.rosterCodes);
    this.rosterSummaryLine = _.cloneDeep(data.rosterSummaryLine);
    this.rosterProjects = _.cloneDeep(data.rosterProjects);
    this.employers = _.cloneDeep(data.employers);

    // The value of this.rosterSummaryLine.companyCode is comma seperated employer IDs. We need convert these IDs
    // into the array of Employer.
    this.selectedEmployers = this._rosterSummaryLineService.getEmployersByCommaSeperatedIds(this.rosterSummaryLine.companyCode, this.employers)

    this.rosterSummaryLine.groupIds.forEach(id => {
      let index = this.workGroups.findIndex(rg => rg.id === id);
      if (index !== -1){
        this.selectedWorkGroups.push(this.workGroups[index]);
        this.workGroups.splice(index, 1);
      }
    });
  }

  showRosterCodeDropdown(){
    return this.rosterSummaryLine.rosterSummaryFormular && 
      this.rosterSummaryLine.rosterSummaryFormular.id === SummaryFormular.RosterCode;
  }
  
  save(form: NgForm){
    this.errorMessage = "";

    if (form.invalid){
      return false;
    }

    if (!this.rosterSummaryLine.rosterProjectId){
      this.errorMessage = "Please select a roster project for the summary";
      return;
    }

    if (this.selectedEmployers.length === 0){
      this.errorMessage = "Please select at least one company code";
      return;
    }

    if (!this.rosterSummaryLine.title?.trim()){
      this.errorMessage = "Please provide a title for the summary";
      return;
    }

    if (this.rosterSummaryLine.active && !this.rosterSummaryLine.rosterSummaryFormular){
      this.errorMessage = "Please choose a formular for the summary";
      return;
    }

    this.rosterSummaryLine.companyCode = this.selectedEmployers.map(e=>e.id).join(",");
    this.rosterSummaryLine.groupIds = [];
    this.selectedWorkGroups.forEach(rg => this.rosterSummaryLine.groupIds.push(rg.id));
    this._dialogRef.close(this.rosterSummaryLine);
  }

  cancel(){
    this._dialogRef.close();
  }
}